import RoutesMap from '../../route_control/RouteControl'
import logo from '../../assets/images/logo.png'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { Dropdown } from 'antd'
import img_nf from '../../assets/images/default.jpg'
import dayjs from 'dayjs'
import { ChangePassword } from '../../pages/user'
import { toast } from 'react-toastify'
import { SessionManager } from '../../utils'
import { KeyRound, Languages, ListCollapse, Power, UserPen } from 'lucide-react'
import { toggleChangePasswordModal } from '../../redux/slices/globalSlice'
import { signOut } from '../../redux/slices/assets'
import { useTranslation } from 'react-i18next'

export const HeaderImport = {
    RoutesMap,
    logo,
    useNavigate,
    useDispatch,
    Dropdown,
    img_nf,
    dayjs,
    ChangePassword,
    toast,
    SessionManager,
    KeyRound,
    Languages,
    ListCollapse,
    Power,
    UserPen,
    toggleChangePasswordModal,
    signOut,
    useTranslation
}